module.exports = __webpack_public_path__ + "static/media/ambitiousIcon.947d2b22.svg";